import { Routes } from '@angular/router';
import { PageHomeComponent } from './page-home/page-home.component';
import { PageAboutComponent } from './page-about/page-about.component';
import { PageContactComponent } from './page-contact/page-contact.component';
import { PageGalleryComponent } from './page-gallery/page-gallery.component';
import { PageSpicesComponent } from './page-spices/page-spices.component';
import { PageForestComponent } from './page-forest/page-forest.component';
import { PageAgriculturalComponent } from './page-agricultural/page-agricultural.component';
import { PageOthersComponent } from './page-others/page-others.component';

export const routes: Routes = [
    { path: '', component: PageHomeComponent, title: 'HOME | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: 'about', component: PageAboutComponent, title: 'ABOUT | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: 'contact', component: PageContactComponent, title: 'CONTACT | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: 'gallery', component: PageGalleryComponent, title: 'GALLERY | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: 'plain-thermal-roll', component: PageSpicesComponent, title: 'PLAIN THERMAL PAPER ROLL | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: 'color-thermal-roll', component: PageForestComponent, title: 'COLOR THERMAL PAPER ROLL | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: 'printed-thermal-roll', component: PageAgriculturalComponent, title: 'PRINTED THERMAL PAPER ROLL | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: '#', component: PageOthersComponent, title: 'STICKERS | THANVIKA ENTERPRISES - UDUMALAIPETTAI' },
    { path: '#', component: PageOthersComponent, title: 'STICKERS | THANVIKA ENTERPRISES - UDUMALAIPETTAI' }
];
